import React from 'react';
import CommonAS2ErrorsApp from './CommonAS2ErrorsApp';

const CommonAS2ErrorsEntry = () => {
  return <CommonAS2ErrorsApp />;
};

export default CommonAS2ErrorsEntry;
